import {initialStatisticsState, IStatisticsState} from '@app/core/store/state/statistics.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EStatisticsActions, StatisticsActions} from '@app/core/store/actions/statistics.actions';
import {ETURNOVERTYPE} from '@app/core/enums';

export const statisticsReducers = (
	state = initialStatisticsState,
	action: StatisticsActions | ErrorActions,
): IStatisticsState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EStatisticsActions.GetStatistics: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EStatisticsActions.GetStatisticsSuccess: {
			return {
				...state,
				statistics: action.statistics,
				isLoading: false,
			};
		}
		case EStatisticsActions.PatchTurnoverSuccess: {
			const newStats = {...state.statistics};
			if (action.data.type === ETURNOVERTYPE.ACTUAL) {
				newStats.date_with_salary_totals_collection.find(ds => ds.date === action.date.format('YYYY-MM-DD')).turnover_totals_calculation.total_turnover_actual = action.data.turnover;
			} else {
				newStats.date_with_salary_totals_collection.find(ds => ds.date === action.date.format('YYYY-MM-DD')).turnover_totals_calculation.total_turnover_expected = action.data.turnover;
			}

			return {
				...state,
				statistics: newStats,
			};
		}
		case EStatisticsActions.GetSalaryPercentageSuccess: {
			return {
				...state,
				salaryPercentage: action.data,
			};
		}
		case EStatisticsActions.GetSalaryExpenseStatistics: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EStatisticsActions.GetSalaryExpenseStatisticsSuccess: {
			return {
				...state,
				isLoading: false,
				salaryExpenses: action.data,
			};
		}

		case EStatisticsActions.GetRevenueStatistics: {
			return {
				...state,
				isLoading: true,
			};
		}

		case EStatisticsActions.GetRevenueStatisticsSuccess: {
			return {
				...state,
				isLoading: false,
				revenue: action.data,
			};
		}
		case EStatisticsActions.SetStatisticsDateRange: {
			return {
				...state,
				dateRange: action.dateRange,
			};
		}
		default:
			return state;
	}
};
